import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as adminActions from "../../../../../actions/admin.actions";
import * as commonActions from "../../../../../actions/common.actions";
import {
  fetchCompanies,
  searchCompanies,
  getAdminCompanyById
} from "../../../../../actions/company.actions";
import AdminCreateProjects from "../components/AdminCreateProjects";

const subHeader = () => {
  return {
    items: [
      {
        caption: "Project",
        url: `/admin/new/projects`
      },
      {
        caption: "Admin",
        url: `/admin/new/users`
      },
      {
        caption: "Referral Codes",
        url: `/admin/new/referral-codes`
      }
    ],
    activeItem: 0
  };
};

class AdminCreateProjectsContainer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.commonActions.setSubHeader(subHeader());
    this.props.adminActions.getAdminList();
    this.props.fetchCompanies();
  }

  componentWillUnmount() {
    this.props.commonActions.setSubHeader({});
  }

  render() {
    return (
      <div>
        <AdminCreateProjects
          managers={this.props.managers}
          companies={this.props.companies}
          isLoadingCompany={this.props.isLoadingCompany}
          onSearchCompanies={this.props.searchCompanies}
          getAdminCompanyById={this.props.getAdminCompanyById}
          onSubmit={this.handleSubmit}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    managers: state.company.adminCompany.managers,
    companies: state.company.companies.data,
    isLoadingCompany: state.company.isLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    adminActions: bindActionCreators(adminActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    getAdminCompanyById: (id, load) => dispatch(getAdminCompanyById(id, load)),
    fetchCompanies: () => dispatch(fetchCompanies()),
    searchCompanies: query => dispatch(searchCompanies(query))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminCreateProjectsContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/new/projects/containers/AdminCreateProjectsContainer.js